import { AgentPolicySettingsSection } from "@/components/admin/agents/agent-policy-settings-section.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/settings/org/agent-policy",
)({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_policy_title()) }],
	}),
});

function RouteComponent() {
	return <AgentPolicySettingsSection />;
}
